import Bowser from "bowser";

export const clientEnvIsMacOs = () => {
  if (!window.navigator.userAgent) return false;
  return Bowser.getParser(window.navigator.userAgent).getOSName(true) === "macos";
};
